module.exports = __webpack_public_path__ + "Flag-242.53010c1cfd4b33c5ce4345401d986d3f.svg";